import React, { useEffect, useState } from "react";
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Box,
  CircularProgress,
  Heading,
  HStack,
  VStack
} from "@chakra-ui/react";
import TopicCollection from "./TopicCollection";
import CategoryProgress from "./CategoryProgress";
import { useAssessmentContext } from "hooks/assessment";

interface CategoryProps {
  title: string;
  childContent: any[];
  tags: string[]; // may be replaced with id in future
  //id: string;
  toggleGameLiftStreamsInput: any;
}

const Category: React.FC<CategoryProps> = ({ title, childContent, tags, toggleGameLiftStreamsInput }) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Box
      p={3}
      m={3}
      bg="gray.700"
      boxShadow="0px 4px 7px -1px rgba(0, 0, 0, 0.25)"
      borderRadius="10px"
      position="relative"
      w="95%"
    >
      <Accordion width="100%">
        <AccordionItem border="none" isDisabled={false} isFocusable={false}>
          {({ isExpanded }) => (
            <>
              <AccordionButton onClick={toggleAccordion}>
                <HStack width="100%">
                  <Heading size="20px" fontWeight="700" color="E5E5E5" textAlign="left" width="100%">
                    {title}
                  </Heading>
                  <CategoryProgress tags={tags} />
                  <HStack style={{ whiteSpace: "nowrap" }}>
                    <Heading size="16px" fontWeight="300" color="E5E5E5">
                      {childContent.length} tasks
                    </Heading>
                  </HStack>
                </HStack>
                <AccordionIcon transform={isOpen ? "rotate(180deg)" : ""} />
              </AccordionButton>
              {isOpen && (
                  <TopicCollection tags={tags} childContent={childContent} toggleGameLiftStreamsInput={toggleGameLiftStreamsInput}/>
              )}
            </>
          )}
        </AccordionItem>
      </Accordion>
      {!isOpen && <div style={{ height: 0, overflow: "hidden" }}></div>}
    </Box>
  );
};

export default Category;
